import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import moment from 'moment';

export function formatDate(date: string | undefined) {
  if (!date) {
    return '';
  }
  dayjs.extend(LocalizedFormat);
  const auxDate = dayjs(date).format('DD/MM/YYYY');
  const auxTime = dayjs(date).format('HH:mm');
  return `${auxDate} - ${auxTime}`;
}

export function formatFriendlyDate(date: string | undefined, withHour = true) {
  if (date) {
    if (withHour) {
      return moment(date).locale('es-mx').format('ll HH:mm')
    }

    return moment(date).locale('es-mx').format('ll')
  }
}

export function calcDays(date: string) {
  const now = moment(moment().format("YYYY-MM-DD"), "YYYYMMDD");
  const dateToDiff = moment(date, "YYYYMMDD");
  return now.diff(dateToDiff, "days")
}
